module.exports = __webpack_public_path__ + "static/media/cover1.6f44c7ba.png";